import { watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useDoctorProfile, type DoctorProfileOptions } from "@/composables/useDoctorProfile";
import { useDoctorSchedule } from "@/composables/useDoctorSchedule";

export type { DoctorProfileOptions };

export function useProfile(options: DoctorProfileOptions = {}) {
  const route = useRoute();
  const profile = useDoctorProfile(options);
  const schedule = useDoctorSchedule(profile.doctor);

  async function loadProfile(): Promise<void> {
    await profile.loadProfile(schedule.applyScheduleFromProfile);
  }

  watch([() => route.params, () => route.query], () => loadProfile(), {
    deep: true,
  });

  onMounted(() => loadProfile());

  return {
    ...profile,
    ...schedule,
    loadProfile,
  };
}
